<script lang="ts" setup>
import type { HTMLAttributes } from "vue";

import { cn } from "@/lib/utils";
import { reactiveOmit } from "@vueuse/core";
import type { SelectSeparatorProps } from "reka-ui";
import { SelectSeparator } from "reka-ui";

const props = defineProps<SelectSeparatorProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <SelectSeparator :class="cn('bg-muted -mx-1 my-1 h-px', props.class)" v-bind="delegatedProps" />
</template>
